import i18n from 'i18next';

const arrayUtilities = {
  filterDataBySearch: (search, data, searchedFields) => {
    const searchInputs = search.toLowerCase().split(' ');
    return data.filter(item =>
      searchInputs.every(input => {
        return searchedFields.some(field => {
          if (field === 'roleName') {
            return i18n
              .t(`Employees.${item[field]}`, { defaultValue: item[field] })
              .toLowerCase()
              .includes(input);
          }
          return item[field].toLowerCase().includes(input);
        });
      }),
    );
  },

  uniquifyArrayByKeys: (arr, keys) => {
    return Object.values(
      arr.reduce((a, c) => {
        a[keys.map((item, index) => (index === keys.length ? c[item] : c[item] + '|'))] = c;
        return a;
      }, {}),
    );
  },
};

export default arrayUtilities;
